import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `GrupoUsuario/cambiarEstadoGrupoUsuarioSeleccion`, method: 'POST', body: list, token: token})
}
